import React, { useEffect } from 'react';
import Carousel from '../components/Carousel';
import './css/home.css';

import video2 from '../img/video/Crown reseidens.mp4';

import image1 from '../img/viber_image_2025-06-03_19-39-14-440.jpg';
import image2 from '../img/viber_image_2025-06-03_19-39-14-965.jpg';
import image3 from '../img/viber_image_2025-06-03_19-39-15-646.jpg';
import image4 from '../img/viber_image_2025-06-03_19-39-16-206.jpg';
import image5 from '../img/viber_image_2025-06-03_19-39-16-754.jpg';
import image6 from '../img/viber_image_2025-06-03_19-39-17-368.jpg';
import image7 from '../img/viber_image_2025-06-03_19-39-17-922.jpg';
import image8 from '../img/viber_image_2025-06-03_19-39-18-464.jpg';
import image9 from '../img/viber_image_2025-06-03_19-39-18-975.jpg';
import image10 from '../img/viber_image_2025-06-03_19-39-19-524.jpg';
import image11 from '../img/viber_image_2025-06-03_19-39-20-050.jpg';
import image12 from '../img/viber_image_2025-06-03_19-39-20-581.jpg';
import image13 from '../img/viber_image_2025-06-03_19-39-21-272.jpg';
import image14 from '../img/viber_image_2025-06-03_19-39-21-995.jpg';
import image15 from '../img/viber_image_2025-06-03_19-39-22-508.jpg';
import image16 from '../img/viber_image_2025-06-03_19-39-23-025.jpg';
import image17 from '../img/viber_image_2025-06-03_19-39-23-562.jpg';
import image18 from '../img/viber_image_2025-06-03_19-39-24-112.jpg';
import image19 from '../img/viber_image_2025-06-03_19-39-24-651.jpg';


const carouselItems = [
    {
        id: 0,
        type: 'video' as const,
        src: video2,
        alt: 'Crown Residence Animation',
        // description: 'Experience Crown Residence - Luxury Living Redefined',
        // fullWidth: true
    },
    {
        id: 1,
        type: 'image' as const,
        src: image1,
        alt: 'Crown Residence Exterior',
    },
    {
        id: 2,
        type: 'image' as const,
        src: image2,
        alt: 'Crown Residence Interior'
    },
    {
        id: 3,
        type: 'image' as const,
        src: image3,
        alt: 'Crown Residence Design'
    },
    {
        id: 4,
        type: 'image' as const,
        src: image4,
        alt: 'Crown Residence Architecture'
    },
    {
        id: 5,
        type: 'image' as const,
        src: image5,
        alt: 'Crown Residence Living Space'
    },
    {
        id: 6,
        type: 'image' as const,
        src: image6,
        alt: 'Crown Residence Amenities'
    },
    {
        id: 7,
        type: 'image' as const,
        src: image7,
        alt: 'Crown Residence View'
    },
    {
        id: 8,
        type: 'image' as const,
        src: image8,
        alt: 'Crown Residence Kitchen'
    },
    {
        id: 9,
        type: 'image' as const,
        src: image9,
        alt: 'Crown Residence Bedroom'
    },
    {
        id: 10,
        type: 'image' as const,
        src: image10,
        alt: 'Crown Residence Bathroom'
    },
    {
        id: 11,
        type: 'image' as const,
        src: image11,
        alt: 'Crown Residence Building'
    },
    {
        id: 12,
        type: 'image' as const,
        src: image12,
        alt: 'Crown Residence Facilities'
    },
    {
        id: 13,
        type: 'image' as const,
        src: image13,
        alt: 'Crown Residence Location'
    },
    {
        id: 14,
        type: 'image' as const,
        src: image14,
        alt: 'Crown Residence Garden'
    },
    {
        id: 15,
        type: 'image' as const,
        src: image15,
        alt: 'Crown Residence Parking'
    },
    {
        id: 16,
        type: 'image' as const,
        src: image16,
        alt: 'Crown Residence Security'
    },
    {
        id: 17,
        type: 'image' as const,
        src: image17,
        alt: 'Crown Residence Community'
    },
    {
        id: 18,
        type: 'image' as const,
        src: image18,
        alt: 'Crown Residence Design Details'
    },
    {
        id: 19,
        type: 'image' as const,
        src: image19,
        alt: 'Crown Residence Overview'
    },
];

const Home: React.FC = () => {
    useEffect(() => {
        // Create and play a silent audio to satisfy browser autoplay policies
        const unlockAudio = () => {
            const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
            const oscillator = audioContext.createOscillator();
            const gainNode = audioContext.createGain();

            oscillator.connect(gainNode);
            gainNode.connect(audioContext.destination);

            oscillator.frequency.value = 1; // Very low frequency (inaudible)
            gainNode.gain.value = 0.001; // Almost silent

            oscillator.start();
            setTimeout(() => {
                oscillator.stop();
                audioContext.close();
            }, 100);
        };

        // Try to unlock audio when user interacts with page
        const handleInteraction = () => {
            unlockAudio();
            document.removeEventListener('click', handleInteraction);
            document.removeEventListener('touchstart', handleInteraction);
        };

        document.addEventListener('click', handleInteraction);
        document.addEventListener('touchstart', handleInteraction);

        return () => {
            document.removeEventListener('click', handleInteraction);
            document.removeEventListener('touchstart', handleInteraction);
        };
    }, []);

    return (
        <div className="home-page">
            <Carousel
                items={carouselItems}
                autoPlay={false}
            />
        </div>
    );
};
export default Home;